import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import BaseCard from '../BaseCard';
import CardMemberAvatar from '@atoms/CardMemberAvatar';
import { LinkSmall } from '@styled';
import getFavoriteHook from '@hooks/getFavoriteHook';

const MemberCard = ({
    id,
    firstName,
    lastName,
    fullName,
    companyID,
    companyName,
    title,
    designations,
    displayLocation,
    businessType,
    photoURL,
    showFavoriteIcon,
    url,
    onClick,
    isFavorite: initialIsFavorite,
    isLoggedIn = true,
}) => {
    const history = useHistory();
    const useFavorite = getFavoriteHook({ type: 'contact', initialIsFavorite });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite } = useFavorite();

    const onFavorite = () => {
        if (isFavorite) {
            removeFavorite(id);
        } else {
            saveFavorite(id);
        }
    };

    return (
        <BaseCard
            id={id}
            type="member"
            title={fullName}
            url={url}
            onClick={onClick}
            isFavorite={isFavorite}
            onFavorite={onFavorite}
            isLoadingFavorite={isLoadingFavorite}
            isLoggedIn={isLoggedIn}
            showFavoriteIcon={showFavoriteIcon}
            showShareIcon={false}
            imageBlock={
                <div className="d-flex justify-content-center mt-4">
                    <CardMemberAvatar
                        firstName={firstName}
                        lastName={lastName}
                        fullName={fullName}
                        photoURL={photoURL}
                        sizeDesktop={120}
                    />
                </div>
            }
            contentBlock={
                <>
                    <a
                        href={url}
                        onClick={() => onClick(url)}
                        onKeyDown={() => onClick(url)}
                        className="profile-name-link"
                    >
                        <h3 className="mt-3 mb-0 text-center member-name display6 bold">
                            {fullName}
                            {designations && <span>{designations}</span>}
                        </h3>
                    </a>
                    <p className="mt-2 mb-0 text-center display8 secondary member-title">{title}</p>
                    <p className="mt-2 mb-0 text-center display8 secondary member-title">{displayLocation}</p>

                    {(companyID || companyName) && (
                        <LinkSmall
                            href={`/company/profile/${companyID}`}
                            className="d-inline-block mt-2 text-center text-md w-100"
                            onClick={e => {
                                onClick();

                                // History is undefined if called from within a modal
                                if (!history) {
                                    return;
                                }

                                e.preventDefault();
                                history.push(`/company/profile/${companyID}`, { state: { inApp: true } });
                            }}
                        >
                            {companyName + (businessType && businessType.length > 0 ? ` (${businessType[0]})` : '')}
                        </LinkSmall>
                    )}
                </>
            }
        />
    );
};

MemberCard.propTypes = {
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    fullName: PropTypes.string,
    companyID: PropTypes.number,
    companyName: PropTypes.string,
    title: PropTypes.string,
    designations: PropTypes.string.isRequired,
    displayLocation: PropTypes.string,
    businessType: PropTypes.array.isRequired,
    photoURL: PropTypes.string,
    showFavoriteIcon: PropTypes.bool,
    onClick: PropTypes.func,
    url: PropTypes.string,
    isFavorite: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool,
};

export default MemberCard;
